/** @file actorKind: whether a revision-log actor is the human (a browser session) or an agent (a token). */

/**
 * The server logs `session:<owner>` for the browser, `token:<id>` for agents (MCP, CLI), `undo:<actor>` for an undo
 * on behalf of `<actor>`; the editor's live socket says `editor`. Anything else counts as an agent.
 */
export function actorKind(actor: string): 'human' | 'agent' {
  const who = actor.startsWith('undo:') ? actor.slice(5) : actor;
  return who.startsWith('session:') || who === 'editor' ? 'human' : 'agent';
}
